class QuizQuestion {
	/**
	 * QuizQuestion constructor
	 * @param {{
	 * 		title: String,
	 * 		additional_text: String,
	 * 		key: String,
	 * 		iconSVG: String,
	 * 		stepIndex: Number,
	 * 		answers: {title: String, key: String, "redirect-to-page": Number}[]
	 * 	}} questionData
	 */
	constructor(questionData) {
		this._title = questionData.title;
		this._additional_text = questionData.additional_text;
		this._key = questionData.key;
		this._stepIndex = questionData.stepIndex;
		this._iconSVG = questionData.iconSVG;
		this._answers = questionData.answers;
		/** @type {String|null} */
		this._selectedAnswer = null;
	}

	get title() {
		return this._title;
	}

	get additional_text() {
		return this._additional_text;
	}

	get key() {
		return this._key;
	}

	get stepIndex() {
		return this._stepIndex;
	}

	get iconSVG() {
		return this._iconSVG;
	}

	/**
	 * @return {{title: String, key: String, 'redirect-to-page': Number}[]}
	 */
	get answers() {
		return this._answers;
	}

	get selectedAnswer() {
		return this._selectedAnswer;
	}

	set selectedAnswer(value) {
		this._selectedAnswer = value;
	}
}
